import React from 'react'
import { css } from '@emotion/react'
import { Dropdown } from 'util/ui'
import { SUI } from 'shared/ui'

export default class MailboxSelectorDropdown extends React.PureComponent {
  handleMailboxClick = (e, data) => {
    const mailboxId = data.value
    const { onChange, doRememberPreviousMailbox } = this.props
    onChange(mailboxId)
    doRememberPreviousMailbox(mailboxId)
  }

  buildOptions = mailboxes => {
    return (
      mailboxes
        // .filter(box => !value || box.id !== value)
        .map(({ email, name, id }) => ({
          key: id,
          value: id,
          text: `${name} <${email}>`,
          onClick: this.handleMailboxClick,
        }))
    )
  }

  render() {
    const { mailboxes, value, ...rest } = this.props
    return (
      <SUI
        css={css`
          width: 100%;
        `}
      >
        <Dropdown
          options={this.buildOptions(mailboxes)}
          value={value || (mailboxes[0] && mailboxes[0].id)}
          {...rest}
        />
      </SUI>
    )
  }
}
